import BaseAtomView from 'views/atoms/base-atom-view';
import ButtonTemplate from './templates/button-atom';

const ButtonAtomView = BaseAtomView.extend({
  template: ButtonTemplate,
  initialize: function () {
    BaseAtomView.prototype.initialize.apply(this, arguments);
  },
});

export default ButtonAtomView;
